<template>
    <div class="deal_index_box">
        <!-- 資金管理 -->
        <div class="deal_title">
            <div>資金管理<span>》</span>帳戶流水</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box"  v-show="detailsTF" v-loading="inquireTF">
            <div class="deal_content_title">帳戶流水</div>
            <div class="deal_content">
                <div class="center_box">
                    <!-- 帳戶流水 -->
                    <el-form ref="form" :model="form" label-width="90px">
                        <el-form-item label="帳號類型：">
                            <el-radio-group v-model="typeRadio">
                                <el-radio-button label="基本帳戶"></el-radio-button>
                                <!-- <el-radio-button label="手續費帳戶"></el-radio-button>
                                <el-radio-button label="退款帳戶"></el-radio-button>
                                <el-radio-button label="支出帳戶"></el-radio-button> -->
                            </el-radio-group>
                            <div class="hint_box">
                                <i class="el-icon-question"></i>
                                <div class="hint_text">手續費帳戶、退款帳戶、支出帳戶需申請後獨立分離</div>
                                <div class="hint_triangle"></div>
                            </div>
                        </el-form-item>
                        <el-form-item label="申請時間：">
                            <el-date-picker
                                v-model="dateValue"
                                type="daterange"
                                align="center"
                                value-format="timestamp"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="deal_content_span">查詢期日不可超過31天</span>
                        </el-form-item>
                        <el-form-item label="UID查詢：" v-show="this.$store.state.uid == '1' ">
                            <el-input class="uid_class" placeholder="" v-model="uidClass" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="業務類型：">
                            <el-select v-model="typeVal" placeholder="所有付款類型" @change="optionsFun">
                                <el-option
                                v-for="item in options2"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="狀態：">
                            <el-select v-model="statusVal" placeholder="所有付款類型">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <!-- 查詢按钮 -->
                    <div class="inquire_button">
                        <el-button type="primary" @click="inquireFun()">查詢</el-button>   
                        <el-input v-model="input" placeholder="請輸入業務單號查詢" class="input_box">
                            <el-button slot="append" icon="el-icon-search" @click="inquireFun()"></el-button>
                        </el-input>
                    </div>
                    <!-- 表单 -->
                    <div class="table_download">
                        <span v-show="currentPage == '1'">
                            <span class="col_red">總筆數：</span><span>{{form.count}}筆</span>
                            <span class="col_red">狀態：</span><span>{{form.type}}</span>
                            <span class="col_red">入帳金額：</span><span>{{form.trader}}元</span>
                            <span class="col_red">支出金額：</span><span>{{form.appropriation}}元</span>
                        </span>
                        <el-button type="primary" plain class="table_download_button"  @click="ExcelFun('exportexcel')">帳單匯出</el-button>
                    </div>
                    <div>
                         <!-- 表单头 -->
                            <div class="table_header">
                                <div class="table_date">記帳時間</div>
                                <div class="table_uid">UID</div>
                                <div class="table_merchantorder">業務單號</div>
                                <div class="table_account_type">業務類型</div>
                                <div class="table_money">收入</div>
                                <div class="table_commission">支出</div>
                                <div class="table_period">可提領日期</div>
                                <div class="table_status">狀態</div>
                                <div class="table_balance">結餘</div>
                                <div class="table_operation">操作</div>
                            </div>
                            <!-- 表单内容 -->
                            <div class="table_maxbox" v-for="(list, index) of pagelist" :key="index" v-show="currentPage == (index+1)">
                                <div class="table_content" v-for="item of list" :key="item.id">
                                    <div class="table_date">{{item.transaction_time}}</div>
                                    <div class="table_uid">{{item.uid}}</div>
                                    <div class="table_merchantorder">{{item.pay_order_num}}</div>
                                    <div class="table_account_type">{{item.type}}</div>
                                    <div class="table_money">{{item.pay_money}}</div>
                                    <div class="table_commission">{{item.zc}}</div>
                                    <div class="table_period">{{item.period}}</div>
                                    <div class="table_status">{{item.status}}</div>
                                    <div class="table_balance">{{item.reach_money}}</div>
                                    
                                    <div class="table_operation">
                                        <span @click="detailsFun(item.id, item.time)">
                                            <span>查看</span><i class="el-icon-view"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        <!-- 表单分页列表 -->
                        <div class="table_pagination">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 30, 50]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalNumber"
                                >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- deal_index_box -->
        <!-- 訂單詳情 -->
        <statement-details v-show="!detailsTF" @detailsFun="detailsFun()"></statement-details>
    </div>
</template>

<script>
import StatementDetails from '../../common/StatementDetails.vue';
import axios from 'axios';

export default {
    name: 'LoginDealStatement',
    data() {
        return {
            form:{
                sr: '0',
                sr_b: '0',
                zc: '0',
                zc_b: '0'
            },
            typeRadio: '基本帳戶',
            input: '',
            // 查询时候加载状态
            inquireTF: false,
            // 訂單詳情切換
            detailsTF: true,
            // 日期
            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            options: [ {
                value: '',
                label: '全部狀態'
            }, {
                value: '可提領',
                label: '可提領'
            }, {
                value: '不可提領',
                label: '不可提領'
            }],
            options2: [ {
                value: '',
                label: '全部業務類型'
            }, {
                value: '1',
                label: '交易'
            }, {
                value: '2',
                label: '提領/拒提'
            }, {
                value: '3',
                label: '跨行提領手續費'
            }],
            uidVal: '1',
            uidClass: '1',
            dateValue: '',
            typeVal: '',
            statusVal: '',
            start_time: '',
            end_time: '',
            paymentValue: '',
            transactionValue: '',
            // 表单
            tableData: [],
            totalNumber: 0,
            currentPage: 1,
            pageSize: 10,
            pagelist:[]
        // return
        }
    },
    components: {
        StatementDetails
    },
    methods: {
        optionsFun(){
            if( this.typeVal == '2' ){
                this.statusVal = '';
                this.options = [{
                    value: '',
                    label: '全部狀態'
                }];
            } else {
                this.statusVal = '';
                this.options = [{
                    value: '',
                    label: '全部狀態'
                }, {
                    value: '可提領',
                    label: '可提領'
                }, {
                    value: '不可提領',
                    label: '不可提領'
                }];
            }
        },
        handleClick(tab, event) {
            // console.log(tab, event);
        },
       handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.pagelist = this.pagesFun(val);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
        },
        // FUN-訂單詳情
        detailsFun(id, time){
            this.detailsTF = !this.detailsTF;
            axios.get(this.$store.state.axiosStatementUrl, {
                params: {
                    do: 'details',
                    id: id,
                    time: time,
                    uid: this.$store.state.uid,
                }
            }).then((res) => {
                // console.log(res.data);
                if(res.data.message){
                    this.$store.commit('changeDetails',res.data.message);
                }
            })
        },
        // FUN-分頁顯示
        pagesFun(number){
            let pages=[];
            this.tableData.forEach((item,index)=>{
                var page=Math.floor(index/number);
                if(!pages[page]){
                    pages[page]=[];
                }
                pages[page].push(item);
            })
            return pages;
        },
        // FUN-EXCEL下載
        ExcelFun(hxr){
            let txt_url = '';
            let charset = '';
            let uidvalue = '';
            // 简体还是繁体
            if (navigator.language === "zh-TW"){
                charset = "BIG5";
            } else {
                charset = "GBK";
            }
            // 是否UID
            if (this.uidClass == ''){
               uidvalue = this.$store.state.uid;
            } else {
               uidvalue = this.uidClass;
            }

            // 交易时间：
            // const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            // this.start_time = start.getTime().toString();
            // this.start_time = this.start_time.substring(0, 10);
            // this.end_time = this.start_time;
            // console.log(this.start_time);

            // 下载：
            txt_url = this.$store.state.axiosStatementUrl
                +'&uid='+uidvalue
                +'&type='+this.typeVal
                +'&status='+this.statusVal
                +'&end_time='+this.end_time
                +'&start_time='+this.start_time
                +'&code='+this.input
                +'&charset='+charset
                +'&do='+hxr;

            window.location.href = txt_url;
        },
        // FUN-订单查询
        inquireFun(){

            // 交易时间：
            if( this.dateValue ){
                this.end_time = this.dateValue[1].toString();
                this.end_time = this.end_time.substring(0, 10);
                this.start_time = this.dateValue[0].toString();
                this.start_time = this.start_time.substring(0, 10);
                // 交易狀態:
                this.transactionValue = '1';
            } else {
                this.dateValue = '';
                this.end_time = '';
                this.start_time = '';
            }

            this.inquireTF = true;
            axios.get(this.$store.state.axiosStatementUrl, {
                params: {
                    type: this.typeVal,
                    status: this.statusVal,
                    start_time: this.start_time,
                    end_time: this.end_time,
                    uid: this.uidClass,
                    code: this.input,
                }
            }).then((res) => {
                // console.log(res.data);
                this.inquireTF = false;
                this.form = res.data.message[0];
                //  this.tableData = res.data.message[1];
                this.currentPage = 1;
                 if(res.data.message[1]){
                    if(res.data.status){
                        // console.log(res.data);
                        this.tableData = res.data.message[1];
                        this.totalNumber = res.data.message[1].length;
                        this.pagelist = this.pagesFun(this.pageSize);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error',
                            duration: 1000
                        });
                    }
                 } else {
                    this.$message({
                        showClose: true,
                        message: '沒有數據',
                        type: 'error',
                        duration: 1000
                    });
                    this.tableData = [];
                    this.pagelist = this.pagesFun(this.pageSize);
                    this.totalNumber = 0;
                }
            })
        },
    },
    mounted() {
        this.uidClass = this.$store.state.uid;

        if(this.$store.state.dateValTF != '0' ){
            this.dateValue = this.$store.state.dateVal;
            this.uidClass = this.$store.state.dateValUid;
            this.typeVal = this.$store.state.dateValType;
            this.statusVal = '';
            this.inquireFun();
        } else {
            let start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            start = start.getTime();
            let end = new Date(new Date(new Date().toLocaleDateString()).getTime());
            end = end.getTime();
            let list = [];
            list[0] = start;
            list[1] = end;
            this.dateValue = list;
            this.statusVal = '可提領';
            this.inquireFun();
        }
        this.$emit('moneybillsFun');

    },
    destroyed(){
        let trueTF = {};
            trueTF.trueTF = '0';
            trueTF.uid = '';
            trueTF.type = '';
        this.$store.commit('changeDateValTF',trueTF);
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .col_red {
        color: #E73262;
    }
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .uid_class {
        width: 350px;
    }
    .hint_box {
        font-size: 15px;
        display: inline-block;
        color: #26b5d2;
        margin-left: 8px;
        position: relative;
    }
    .hint_box:hover .hint_text {
        display: block;
    }
    .hint_box .hint_text {
        display: none;
        box-sizing: border-box;
        position: absolute;
        bottom: -12px;
        left: 6px;
        border: 1px solid #26b5d2;
        line-height: 19px;
        font-size: 11px;
        color: #777;
        width: 286px;
        padding: 0 4px;
    }
    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
        letter-spacing: 1px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 20px;
        padding-top: 26px;
    }
    .center_box {
        min-width: 900px;
        margin: 10px 65px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
        width: 960px;
    }
    .deal_content_tab_first > div {
        margin: 14px 0;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .inquire_button {
        padding: 10px;
    }
    .input_box {
        width: 300px;
        margin-left: 10px;
    }
    /* 表单 */
    .table_download {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 6px 0;
    }
    .table_download_button {
        padding: 6px 10px;
    }
    .table_download >span {
        margin: 0 5px;
    }
    .table_download span span {
        display: inline-block;
        margin: 0px 5px;
    }
    /* 表单头 */
    .table_header {
        height: 36px;
        line-height: 36px;
        background: #f2f2f2;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .table_maxbox >div+div {
        border-top: 1px solid #e7e7e7;
    }
    .table_content {
        padding: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }
     .table_date {
        box-sizing: border-box;
        width: 10%;
        padding: 0 10px;
        text-align: center;
    }
     .table_uid {
        box-sizing: border-box;
        width: 6%;
        padding: 0 10px;
        text-align: center;
    }
    .table_merchantorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 15%;
        padding: 0 10px;
        text-align: center;
        /* min-width: 160px; */
    }
    .table_account_type {
        box-sizing: border-box;
        width: 9%;
        padding-left: 14px;
        padding-right: 10px;
        text-align: center;
    }
    .table_money {
        box-sizing: border-box;
        width: 9%;
        padding: 0 10px;
        text-align: center;
    }
    .table_period {
        box-sizing: border-box;
        width: 12%;
        padding: 0 10px;
        text-align: center;
    }
    .table_commission {
        box-sizing: border-box;
        width: 9%;
        padding: 0 10px;
        text-align: center;
    }
    .table_status {
        box-sizing: border-box;
        width: 10%;
        padding: 0 10px;
        text-align: center;
    }
    .table_balance {
        box-sizing: border-box;
        width: 10%;
        padding: 0 10px;
        text-align: center;
    }
    .table_operation {
        padding: 0 10px;
    }
    .table_operation > span {
        margin-right: 10px;
        cursor: pointer;
    }
    .table_operation > span > span {
        margin-right: 2px;
        padding-bottom: 2px;
        border-bottom: 1px solid;
    }
/* 分页 */
    .table_pagination {
        display: flex;
        margin: 20px;
        justify-content: flex-end;
    }
    .annotation {
        font-size: 11px;
        color: #777;
    }
    .annotation > p {
        line-height: 17px;
        margin-left: 18px;
    }
    .annotation .annotation_p {
        margin: 0px;
        margin-top: 10px;
    }
    .annotation .annotation_span {
        border-bottom: 1px solid #326ede;
        color: #326ede;
    }
</style>
